import { useEffect, useState } from 'react';
import { deleteInvestment, IDryRunDeleteResponse } from '../../../services/queries/MaggieTransactionQueries';

export function useDryRunDeleteInvestment(id: number) {
  const [loading, setLoading] = useState<boolean>(true);
  const [nAttachedTransactions, setNAttachedTransactions] = useState<number>();

  useEffect(() => {
    let cancelled = false;

    deleteInvestment(id, true)
      .then((data) => {
        if (cancelled) {
          return;
        }
        if (data) {
          setNAttachedTransactions((data as IDryRunDeleteResponse).attachedTransactions);
        }
      })
      .catch(() => {
        // swallow — loading is reset in finally
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { loading, nAttachedTransactions };
}
